/* DailyHaulDeals first-party engagement v1. No persistent visitor identifier. */
(function () {
  'use strict';
  if (window.__dhdAnalyticsLoaded || (window.Shopify && window.Shopify.designMode)) return;
  window.__dhdAnalyticsLoaded = true;
  var endpoint = 'https://flow.brasileasy.com/webhook/dhd-storefront-events-v1';
  var pageId = crypto.randomUUID();
  var path = location.pathname;
  var test = new URLSearchParams(location.search).get('dhd_test') === '1';
  var seen = new Set();
  var lastClick = new Map();
  var sentPage = false; var sentSearch = false;
  var observer;
  var timers = new Map();
  var placement = path.indexOf('/products/') === 0 ? 'product' : path.indexOf('/collections/') === 0 ? 'collection' : path === '/' ? 'home' : 'other';
  function allowed() {
    if (navigator.globalPrivacyControl === true || navigator.doNotTrack === '1') return false;
    return !!(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.analyticsProcessingAllowed());
  }
  function send(type, productId, suffix, searchKeys) {
    if (!allowed()) return;
    var payload = {event_id: pageId + '.' + suffix, event_type:type, page_id:pageId, path:path, placement:placement, product_id:productId || '', occurred_at:new Date().toISOString(), consent:true, is_test:test}; if(type === 'internal_search') payload.search_keys=searchKeys;
    var body = new URLSearchParams({event:JSON.stringify(payload)});
    fetch(endpoint, {method:'POST',mode:'cors',credentials:'omit',referrerPolicy:'no-referrer',keepalive:true,body:body}).catch(function () {});
  }
  function impression(element) {
    var id = element.getAttribute('data-product-id');
    if (!id || seen.has(id) || !allowed()) return;
    seen.add(id);
    send('offer_view',id,'view.'+id);
  }
  function recordSearch() { if(sentSearch || path !== '/search' || !allowed()) return; var q=new URLSearchParams(location.search).get('q')||''; if(!q || q.length>120) return; var patterns=[["dyson","dyson"],["wavytalk","wavytalk"],["tymo","tymo"],["shark","shark"],["julep","julep"],["hero","hero|mighty patch"],["arencia","arencia"],["medicube","medicube"],["it-cosmetics","it cosmetics|cc\\+?"],["hair-dryer","hair dryer|blow dryer|secador"],["curling-iron","curling|curler|babyliss"],["hair-straightener","straightener|flat iron|chapinha|prancha"],["thermal-brush","thermal brush|heated brush|escova termica"],["multi-styler","multi.?styler|flexstyle"],["serum","serum|vitamin c"],["pimple-patch","pimple|acne patch|mighty patch"],["eyeshadow","eyeshadow|eye shadow|sombra"],["cc-cream","cc cream|cc\\+|color correcting"],["hair-care","hair care|cabelo"],["skincare","skincare|skin care|pele"],["makeup","makeup|make up|maquiagem"]]; var keys=patterns.filter(function(p){return new RegExp(p[1],'i').test(q);}).map(function(p){return p[0];}).slice(0,8); if(keys.length){ sentSearch=true; send('internal_search','','search',keys); } }
  function start() {
    document.documentElement.setAttribute('data-dhd-analytics', allowed() ? 'active' : 'waiting-consent');
    if (!allowed()) {
      timers.forEach(clearTimeout); timers.clear();
      if (observer) observer.disconnect();
      return;
    }
    recordSearch();
    if (!sentPage) { sentPage=true; send('page_view','','page'); }
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var element = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          if (!timers.has(element)) timers.set(element,setTimeout(function () {impression(element);timers.delete(element);},1000));
        } else if (timers.has(element)) {clearTimeout(timers.get(element));timers.delete(element);}
      });
    },{threshold:[0,0.5]});
    document.querySelectorAll('[data-dhd-affiliate="true"][data-product-id]').forEach(function (element) {
      if (element.id === 'dhd-affiliate-product') impression(element);
      else observer.observe(element);
    });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-dhd-affiliate-link]');
    if (!link || !allowed()) return;
    var element = link.closest('[data-dhd-affiliate="true"][data-product-id]');
    if (!element) return;
    var id=element.getAttribute('data-product-id'), now=Date.now();
    if (now-(lastClick.get(id)||0)<750) return;
    lastClick.set(id,now); impression(element);
    send('affiliate_click',id,'click.'+crypto.randomUUID());
  },true);
  document.addEventListener('visitorConsentCollected',start);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],function (error) {
      if (!error) start();
      else document.documentElement.setAttribute('data-dhd-analytics','privacy-api-unavailable');
    });
  } else {
    document.documentElement.setAttribute('data-dhd-analytics','privacy-api-unavailable');
  }
}());